import React, { useEffect, useState } from "react";
import { Util } from "@xt/xtbase";
import { getAdvertSpace } from "@/api/xt-app";
import styles from "./index.module.less";

const { getUrl } = Util;

const FLOATING_AD_CLOSED_KEY = "ssr-web-index-floating-ad-1000-closed";

export default function FloatingAdvert() {
  const [ad, setAd] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && sessionStorage.getItem(FLOATING_AD_CLOSED_KEY)) {
      return;
    }
    getAdvertSpace({ spaceId: 1000 })
      .then((res) => {
        const payload = res?.data?.data ?? res?.data ?? res;
        if (!payload || !payload.imgUrl) return;
        const img = new Image();
        img.onload = () => setAd(payload) || setVisible(true);
        img.onerror = () => setAd(payload) || setVisible(true);
        img.src = payload.imgFormatUrl || payload.imgUrl;
      })
      .catch(() => {});
  }, []);

  const onClose = (e) => {
    e.stopPropagation();
    sessionStorage.setItem(FLOATING_AD_CLOSED_KEY, "1");
    setVisible(false);
  };

  const onClick = () => {
    if (!ad || !ad.link) return;
    const link = ad.link;
    const isHttp = /^(https?:)?\/\//.test(link);
    if (isHttp) {
      window.open(link);
    } else {
      window.open(getUrl(link));
    }
  };

  if (!visible || !ad) return null;

  return (
    <div className={styles.wrap}>
      <div className={styles.card} onClick={onClick}>
        <button type="button" className={styles.close} onClick={onClose} aria-label="close">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.3536 1.35355C13.5488 1.15829 13.5488 0.841709 13.3536 0.646447C13.1583 0.451184 12.8417 0.451184 12.6464 0.646447L7 6.29289L1.35355 0.646447C1.15829 0.451184 0.841709 0.451184 0.646447 0.646447C0.451184 0.841709 0.451184 1.15829 0.646447 1.35355L6.29289 7L0.646447 12.6464C0.451184 12.8417 0.451184 13.1583 0.646447 13.3536C0.841709 13.5488 1.15829 13.5488 1.35355 13.3536L7 7.70711L12.6464 13.3536C12.8417 13.5488 13.1583 13.5488 13.3536 13.3536C13.5488 13.1583 13.5488 12.8417 13.3536 12.6464L7.70711 7L13.3536 1.35355Z"
              fill="currentColor"
            />
          </svg>
        </button>
        <img
          src={ad.imgFormatUrl || ad.imgUrl}
          alt=""
          className={styles.img}
          style={{ cursor: ad.link ? "pointer" : "default" }}
        />
        {ad.link ? (
          <div className={styles.footer}>
            <span className={styles.label}>{ad.title || ""}</span>
            <span className={styles.arrow}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 2.5L8 6L4.5 9.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
}
